<template>
  <div>
    <Multiselect
      v-model="selectedCat"
      :options="options"
      placeholder="ORDER BY"
      class="gameCat"
    ></Multiselect>
    </div>
</template>



<style lang="scss" scoped>
div{
  width:160px;
}
.gameCat {
  font-family: Play;
  font-weight:bold;
  color:$grey;
  z-index:2000;
  margin: 0px 20px 0px 0px;
  --ms-font-size: 14px;
  --ms-radius: 30px;
  --ms-border-color:$white;
  --ms-bg: linear-gradient(#e3fc00, #a8ba04);
  --ms-dropdown-bg: #a8ba04;
  --ms-placeholder-color: #373946;
}
</style>

<script>
import Multiselect from '@vueform/multiselect';
export default {
  components: {
      Multiselect,
    },
    data(){
        return {
            selectedCat:null,
            options:[
              'Earnings Hi/Lo',
              'Earnings Lo/Hi',
              'Team Name',
              'Previous Rank',
              'Country'
            ]
        }
    },
    watch: {
        selectedCat : function(){
            if (this.selectedCat === null) {this.selectedCat='Earnings Hi/Lo'}
            this.$store.commit("setSortCategory",{category:this.selectedCat});
        }
    },
    mounted(){
      this.selectedCat=this.$store.getters.getSortCat;
    }

}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>